// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__G7TAb","productName":"Table_productName__uddC-"};